import { Link } from "react-router-dom";
import { articles } from "@/mocks/articles";

export default function ArticleList() {
  return (
    <section className="w-full bg-background-100" aria-labelledby="articles-heading">
      <div className="mx-auto w-full max-w-7xl px-4 py-16 md:px-6">
        <div className="flex flex-col items-start justify-between gap-4 sm:flex-row sm:items-end">
          <div>
            <span className="text-sm font-medium text-accent-600">GUIDE</span>
            <h2 id="articles-heading" className="mt-1 font-heading text-2xl text-foreground-900 md:text-3xl">
              漫画推荐指南
            </h2>
            <p className="mt-2 max-w-xl text-sm text-foreground-600">
              由编辑精心整理的漫画推荐大全，为你解读人气排行背后的看点与亮点。
            </p>
          </div>
        </div>

        <div className="mt-8 grid grid-cols-1 gap-5 sm:grid-cols-2 lg:grid-cols-3">
          {articles.map((a) => (
            <Link
              key={a.slug}
              to={`/article/${a.slug}`}
              className="group overflow-hidden rounded-lg border border-background-200/70 bg-background-50 transition-transform duration-300 hover:-translate-y-1"
            >
              <div className="relative h-44 w-full overflow-hidden">
                <img
                  src={a.cover}
                  alt={a.title}
                  className="h-full w-full object-cover transition-transform duration-500 group-hover:scale-105"
                  loading="lazy"
                />
                <span className="absolute left-2 top-2 rounded-full bg-primary-500 px-2.5 py-0.5 text-xs text-background-50">
                  {a.categoryName}
                </span>
              </div>
              <div className="p-5">
                <h3 className="line-clamp-2 text-sm font-medium leading-relaxed text-foreground-900 group-hover:text-primary-600 md:text-base">
                  {a.title}
                </h3>
                <p className="mt-2 line-clamp-2 text-xs leading-relaxed text-foreground-500">{a.excerpt}</p>
                <div className="mt-4 flex items-center justify-between text-xs text-foreground-500">
                  <span className="flex items-center gap-1">
                    <i className="ri-calendar-line" />
                    {a.date}
                  </span>
                  <span className="flex items-center gap-1">
                    <i className="ri-eye-line" />
                    {a.views}
                  </span>
                </div>
              </div>
            </Link>
          ))}
        </div>
      </div>
    </section>
  );
}